// Croatian (default) UI dictionary
const hr = {
  meta: {
    title: "LedgerLens — OCR skeniranje računa za poslovne timove",
    description:
      "Svaki račun skeniran, svaki cent PDV-a evidentiran. LedgerLens automatski čita račune, razlaže PDV i obračunava povrate zaposlenicima.",
    ogTitle: "LedgerLens",
    ogDescription: "Svaki račun skeniran, svaki cent PDV-a evidentiran.",
    imageAlt: "LedgerLens — OCR skeniranje računa i evidencija PDV-a",
    locale: "hr_HR",
  },
  common: {
    appName: "LedgerLens",
    save: "Spremi", saving: "Spremam…", cancel: "Odustani", close: "Zatvori", delete: "Izbriši",
    edit: "Uredi", approve: "Odobri", reject: "Odbij", rescan: "Ponovno skeniraj", back: "Natrag",
    continue: "Nastavi", loading: "Učitavanje…", search: "Traži", clear: "Očisti", reset: "Poništi",
    export: "Izvezi", all: "Sve", yes: "Da", no: "Ne", actions: "Radnje", status: "Status",
    date: "Datum", total: "Ukupno", vat: "PDV", net: "Osnovica", gross: "Ukupno s PDV-om",
    refund: "Naknada", category: "Kategorija", employee: "Partner / Vozač", vendor: "Izdavatelj",
    receiptNo: "Broj računa", currency: "Valuta", language: "Jezik", signIn: "Prijava",
    signOut: "Odjava", email: "E-pošta", password: "Lozinka", name: "Ime i prezime", role: "Rola",
    admin: "Administrator", employeeRole: "Partner / Vozač", accountantRole: "Knjigovođa",
    seats: "Korisnika", plan: "Paket", upgrade: "Nadogradi", send: "Pošalji", sending: "Slanje…",
    recipients: "Primatelji", message: "Poruka", optional: "neobavezno", copy: "Kopiraj",
    revoke: "Ukini", resend: "Pošalji ponovno", dismiss: "Odbaci", download: "Preuzmi",
    active: "Aktivno", disabled: "Onemogućeno",
    from: "Od", to: "Do", receipts: "Računi", none: "Nema", note: "Napomena", you: "vi",
    unlimitedSeats: "Neograničeno",
    free: "Besplatno", perMonth: "/ mjesec", of: "od", tryAgain: "Pokušajte ponovno",
  },
  nav: {
    dashboard: "Nadzorna ploča", scan: "Skeniraj račune", receipts: "Računi",
    duplicates: "Duplikati", reports: "Izvještaji", team: "Tim", settings: "Postavke",
    billing: "Pretplata", myScan: "Skeniraj", myReceipts: "Moji računi", myRefunds: "Naknade",
    readOnly: "Samo pregled", audit: "Zapisnik radnji",
  },
  audit: {
    title: "Zapisnik radnji",
    sub: "Tko je što promijenio i kada — potpuni trag radnji u vašem društvu",
    action: "Radnja", actor: "Korisnik", entity: "Objekt", when: "Vrijeme", details: "Detalji",
    searchPlaceholder: "Ime, radnja ili ID…",
    count: "Prikazano {shown} od {total} zapisa",
    loadMore: "Učitaj još",
    emptyTitle: "Zapisnik je prazan",
    emptyBody: "Sve promjene računa, pravila i tima automatski se bilježe ovdje.",
    emptyFiltered: "Nema zapisa za odabrane filtere.",
    entities: {
      receipt: "Račun", tenant: "Društvo", user: "Korisnik", report: "Izvještaj",
      invite: "Poziv", subscription: "Pretplata",
    },
    actions: {
      tenant_created: "Društvo otvoreno",
      invite_created: "Poziv poslan",
      invite_accepted: "Poziv prihvaćen",
      receipt_uploaded: "Račun poslan",
      receipt_parsed: "Račun pročitan (OCR)",
      receipt_edited: "Račun izmijenjen",
      receipt_approved: "Račun odobren",
      receipt_bulk_approved: "Grupno odobravanje računa",
      receipt_rejected: "Račun odbijen",
      receipt_reprocess: "Ponovno skeniranje",
      receipt_deleted: "Račun izbrisan",
      duplicate_kept: "Duplikat zadržan",
      duplicate_confirmed: "Duplikat potvrđen",
      duplicate_deleted: "Duplikat izbrisan",
      settings_company_updated: "Podaci društva ažurirani",
      settings_vat_rates_updated: "Stope PDV-a ažurirane",
      settings_categories_updated: "Kategorije ažurirane",
      settings_refund_rules_updated: "Pravila naknade ažurirana",
      notifications_updated: "Postavke obavijesti ažurirane",
      team_member_updated: "Član tima ažuriran",
      team_member_removed: "Član tima uklonjen",
      team_refund_override_set: "Osobno pravilo naknade postavljeno",
      team_refund_override_cleared: "Osobno pravilo naknade ukinuto",
      report_exported: "Izvještaj izvezen",
      report_emailed: "Izvještaj poslan e-poštom",
      report_monthly_sent: "Mjesečni izvještaj poslan",
      billing_checkout_started: "Pretplata započeta",
      billing_subscription_activated: "Pretplata aktivirana",
      billing_seats_synced: "Broj korisnika sinkroniziran",
    },
  },
  status: {
    queued: "U redu", processing: "Skeniranje", parsed: "Obrađeno", needs_review: "Za provjeru",
    failed: "Neuspjelo", approved: "Odobreno", rejected: "Odbijeno", uploading: "Uploadanje",
  },
  landing: {
    badge: "OCR skeniranje računa za poslovne timove",
    h1: "Svaki račun skeniran, svaki cent PDV-a evidentiran.",
    sub: "LedgerLens pretvara fotografije računa u strukturirane podatke u nekoliko sekundi: ukupni iznos, broj računa, datum, izdavatelja i potpunu razdiobu PDV-a — te izračuna točno koliko vraćate svojim vozačima i partnerima.",
    ctaPrimary: "Otvori račun za društvo", ctaSecondary: "Prijava",
    trialNote: "14 dana besplatno · 50 skeniranja · bez kartice",
    audience1: "Transport i vozni parkovi", audience2: "Obrtnici i izvođači",
    audience3: "Knjigovodstveni servisi",
    liveExtraction: "Automatsko čitanje",
    howTitle: "Kako radi",
    step: "Korak",
    step1Title: "Fotografiraj",
    step1Body: "Vozači i terenski radnici fotografiraju bilo koji račun — gorivo, gume, dijelovi, alat, hoteli, usluge.",
    step2Title: "Automatski OCR",
    step2Body: "Izdavatelj, broj računa, datum, iznosi i potpuna razdioba PDV-a po stopama čitaju se u sekundama.",
    step3Title: "PDV i naknade",
    step3Body: "Ukupni troškovi i povratni PDV ažuriraju se u stvarnom vremenu, a naknada svakog radnika računa se po vašim pravilima.",
    featuresTitle: "Napravljeno za rad s više društava",
    f1Title: "Stroga izolacija podataka",
    f1Body: "Svaki zapis nosi ID društva i svaki upit je ograničen na njega — društva nikad ne vide tuđe podatke.",
    f2Title: "Nadzorna ploča u stvarnom vremenu",
    f2Body: "Skenirani računi pojavljuju se na ekranu upravitelja s svim pročitanim parametrima i kumulativnim PDV-om.",
    f3Title: "Naknade po vašim pravilima",
    f3Body: "Vratite prilagođeni postotak PDV-a ili ukupnog iznosa, s pravilima po kategoriji, po zaposleniku i ograničenjem po računu.",
    f4Title: "Izvještaji za knjigovodstvo",
    f4Body: "Čisti PDF i CSV obračuni troškova i PDV-a koje vaš knjigovođa može proknjižiti bez prepisivanja.",
    pricingTitle: "Cijena koja pratite vaš tim",
    pricingSub: "Mjesečna osnovna naknada plus cijena po aktivnom korisniku, s uključenim brojem skeniranja i transparentnom cijenom prekoračenja.",
    pricingCta: "Započni besplatno",
    monthlyIncluded: "skeniranja uključeno",
    faqTitle: "Česta pitanja",
    faq1Q: "Koje račune može pročitati?",
    faq1A: "Bilo koji poslovni račun ili fakturu — gorivo, gume, autodijelovi, servis, alat, kancelarijski materijal, hoteli, cestarine i usluge — na većini europskih jezika.",
    faq2Q: "Kako se obrađuje PDV?",
    faq2A: "Svaki račun se razdvaja po stopama PDV-a (25 %, 13 %, 5 %, 0 % kao zadano, potpuno uredivo po društvu), a osnovica, PDV i ukupan iznos uspoređuju se s ispisanim iznosima.",
    faq3Q: "Kako rade naknade zaposlenicima?",
    faq3A: "Vi odlučujete: postotak PDV-a, postotak ukupnog iznosa ili oboje — s pravilima po kategoriji, po zaposleniku i ograničenjem po računu.",
    faq4Q: "Kako su moji podaci odvojeni?",
    faq4A: "Svaki dokument zapisuje se s ID-om vašeg društva i svako čitanje filtrira se po njemu, pa je pristup podacima drugog društva onemogućen po dizajnu.",
    footerRights: "multi-tenant platforma za troškove i PDV",
    demoCategory: "Gorivo",
    unlimitedUsers: "Neograničeno korisnika",
    extraScan: "{price} po dodatnom skeniranju",
    upToSeats: "Do {n} korisnika",
    seatPrice: "+ {price} po korisniku",
    legalTerms: "Uvjeti korištenja", legalPrivacy: "Politika privatnosti",
    legalRefund: "Politika povrata",
  },
  auth: {
    loginTitle: "Prijava",
    loginSub: "Administratori i terenski radnici koriste istu prijavu.",
    heroTitle: "Računi unutra. PDV, iznosi i naknade van.",
    heroSub: "Upravitelji vide svaki skenirani račun u trenutku kad pristigne, s potpunom razdiobom PDV-a i naknadom koju je radnik zaradio.",
    heroFooter: "Stroga izolacija podataka · EU stope PDV-a · PDF i CSV izvoz",
    workEmail: "Poslovna e-pošta",
    demoTitle: "Isprobajte s demo podacima",
    demoSub: "Otvara pripremljeno demo društvo pa možete odmah skenirati.",
    demoAdmin: "Demo administrator", demoDriver: "Demo vozač", demoAccountant: "Demo knjigovođa",
    newCompany: "Novo društvo?", createAccount: "Otvorite račun",
    welcomeBack: "Dobro došli natrag",
    orgTypeLabel: "Kakva ste organizacija?",
    orgTypeHint: "Prilagodit ćemo aplikaciju — možete promijeniti kasnije u Postavkama.",
    orgType_fleet_owner: "Vlasnik flote / Agregator",
    orgType_fleet_owner_hint: "Vozila i vozači, naknade i izvještaji za knjigovođu.",
    orgType_accounting_firm: "Knjigovodstveni servis",
    orgType_accounting_firm_hint: "Vi ste knjigovođa — izravni Synesis / Minimax izvoz i PDV.",
    signupStep1: "1. Društvo", signupStep2: "2. Administrator",
    signupTitle1: "Recite nam o svom društvu", signupTitle2: "Otvorite administratorsku prijavu",
    signupSub: "Vaše društvo dobiva odvojen radni prostor. Vozače, servisere i partnere možete pozvati odmah nakon toga.",
    companyName: "Naziv društva", country: "Država", taxId: "OIB / PDV broj društva (neobavezno)",
    yourName: "Vaše ime i prezime", passwordHint: "Lozinka (min. 6 znakova)",
    createCompany: "Otvori društvo", alreadyHave: "Već imate račun? Prijavite se",
    companyCreated: "Društvo otvoreno — počeo je 14-dnevni probni period",
    inviteJoin: "Pridružite se društvu", invitedAs: "Pozvani ste kao",
    choosePassword: "Odaberite lozinku", joinCompany: "Pridruži se društvu",
    inviteInvalid: "Ovaj poziv više nije važeći", goToSignIn: "Idi na prijavu",
    welcomeTo: "Dobro došli u",
  },
  dash: {
    title: "Nadzorna ploča", sub: "Pregled troškova, PDV-a i naknada u stvarnom vremenu",
    range30: "Zadnjih 30 dana", range90: "Zadnjih 90 dana", range365: "Zadnjih 12 mjeseci",
    rangeAll: "Sve vrijeme",
    scanCta: "Skeniraj račun",
    kpiExpenses: "Ukupni troškovi", kpiExpensesHint: "Ukupan iznos obrađenih, provjerenih i odobrenih računa u odabranom razdoblju.",
    kpiExpensesSub: "računa u obračunu",
    kpiVat: "Povratni PDV", kpiVatHint: "Kumulativni PDV sadržan u računima, razdvojen po stopama u grafikonu.",
    kpiRefunds: "Naknade za isplatu", kpiRefundsHint: "Koliko su radnici i partneri zaradili natrag prema podešenim postocima.",
    kpiRefundsSub: "prema vašim pravilima",
    kpiUnverified: "Neprovjereni računi",
    kpiReview: "Za provjeru", kpiReviewHint: "Računi gdje je OCR bio nesiguran ili se PDV nije poklopio.",
    kpiScans: "Skeniranja ovaj mjesec", kpiScansHint: "Broj skeniranja uključen u vaš paket za tekući mjesec.",
    scanning: "skeniranje", failed: "neuspjelo",
    feedTitle: "Dolazni računi", feedIdle: "Novi skenirani računi pojavljuju se automatski",
    feedActive: "trenutno se skenira…", viewAll: "Prikaži sve",
    emptyTitle: "Još nema računa",
    emptyBody: "Skenirajte prvi račun — izdavatelj, iznosi i razdioba PDV-a čitaju se automatski.",
    vatByRate: "PDV po stopama", vatByRateSub: "Osnovica i PDV po stopi na vašim računima",
    netBase: "Osnovica",
    spendByCategory: "Troškovi po kategoriji", spendOverTime: "Troškovi kroz vrijeme",
    refundsByEmployee: "Naknade po zaposleniku",
    noVatData: "Nema podataka o PDV-u u ovom razdoblju", noCategoryData: "Još nema podataka po kategorijama",
    noReceiptsPeriod: "Nema računa u ovom razdoblju",
    noRefunds: "Naknade se pojavljuju nakon skeniranja računa.",
    vendorEmployee: "Izdavatelj / partner",
    trialWarning: "Iskoristili ste {used} od {total} probnih skeniranja",
    choosePlan: "Odaberi paket",
    duplicatesWarning: "{count} mogućih duplikata čeka provjeru",
    reviewDuplicates: "Provjeri duplikate",
  },
  receipts: {
    payoutEmail: "E-pošta",
    payoutTitle: "Isplata naknada",
    payoutPaid: "Isplaćeno",
    payoutUnpaid: "Za isplatu",
    markPaid: "Označi kao isplaćeno",
    markUnpaid: "Poništi isplatu",
    paidBadge: "Isplaćeno",
    unpaidBadge: "Za isplatu",
    paidToast: "Naknada označena kao isplaćena",
    paidBulkToast: "{count} naknada označeno kao isplaćeno ({amount})",
    unpaidToast: "Isplata poništena",
    paidOn: "Isplaćeno {when} · {who}",
    payoutFilter: "Isplata",
    payoutAll: "Sve",
    exportLayout: "Format za knjigovodstvo",
    exportMenu: "Izvozi",
    title: "Računi", subCount: "{count} računa prema filtrima",
    searchPlaceholder: "Traži izdavatelja, broj računa, zaposlenika…",
    allCategories: "Sve kategorije", everyone: "Svi",
    selected: "{count} odabrano", approveSelected: "Odobri odabrane", exportCsv: "Izvezi CSV",
    emptyTitle: "Još nema računa", emptyFiltered: "Nema računa za ove filtre",
    emptyBody: "Skenirajte ili fotografirajte prvi račun da počnete pratiti troškove i PDV.",
    emptyBodyFiltered: "Pokušajte očistiti filtre ili proširiti razdoblje.",
    clearFilters: "Očisti filtre", scanCta: "Skeniraj račun",
    filterDuplicates: "Duplikati",
  },
  drawer: {
    uploaded: "poslano", employeeRefund: "Naknada zaposleniku",
    ofVat: "{pct} % PDV-a", ofGross: "{pct} % ukupnog iznosa",
    both: "{vat} % PDV-a + {gross} % ukupnog", categoryRule: "pravilo kategorije",
    employeeRule: "pravilo zaposlenika", capped: "ograničeno",
    litres: "Litara", odometer: "Kilometraža",
    checkBefore: "Provjerite prije odobravanja", vatReconciles: "Iznosi PDV-a poklapaju se s ispisanim ukupnim iznosom",
    duplicateWarning: "Ova slika odgovara računu koji je već poslan.",
    vendorField: "Izdavatelj", taxIdField: "OIB izdavatelja", numberField: "Broj računa",
    dateField: "Datum izdavanja", paymentField: "Način plaćanja",
    netField: "Osnovica", vatField: "PDV", grossField: "Ukupno",
    vatRecap: "Rekapitulacija PDV-a", rate: "Stopa", noRates: "Nije prepoznata stopa PDV-a",
    lineItems: "Stavke", internalNote: "Interna napomena",
    notePlaceholder: "npr. vozilo ZG-1234-AB, nalog #4471",
    saveChanges: "Spremi izmjene", activity: "Aktivnost", loadingImage: "Učitavanje slike…",
    readOnly: "Knjigovodstveni pristup je samo za pregled.",
    savedToast: "Račun ažuriran", refundRecalculated: "Naknada preizračunata",
    approvedToast: "Račun odobren", rejectedToast: "Račun odbijen", deletedToast: "Račun izbrisan",
    rescanToast: "Ponovno skeniram račun…",
  },
  scan: {
    title: "Skeniraj račune",
    sub: "Fotografirajte ili prenesite bilo koji poslovni račun — OCR automatski čita iznose i PDV",
    dropTitle: "Fotografirajte ili prenesite račune",
    splitPdf: "Svaka stranica je zaseban račun",
    splitPdfHint: "Uključite ako je PDF skup više računa. Isključeno: višestranični PDF se čita kao jedan račun.",
    dropSub: "Gorivo, gume, dijelovi, alat, kancelarijski materijal, usluge — bilo koji račun. JPG, PNG, WEBP ili PDF, do 20 odjednom.",
    unsupportedFiles: "{count} datoteka preskočeno — podržani su JPG, PNG, WEBP i PDF.",
    takePhoto: "Fotografiraj", chooseFiles: "Odaberi datoteke",
    sampleTitle: "Nemate račun pri ruci? Skenirajte pravi primjer",
    tipsTitle: "Savjeti za čistu snimku",
    tip1: "Račun poravnajte i ispunite kadar — sva četiri kuta vidljiva.",
    tip2: "Izbjegavajte sjene i odsjaj; dnevno svjetlo je najbolje.",
    tip3: "Dugi računi: obavezno uhvatite dio s ukupnim iznosom i rekapitulacijom PDV-a.",
    recentTitle: "Nedavno skenirano", nothingScanned: "Još ništa nije skenirano.",
    allReceipts: "Svi računi", readingOcr: "OCR čita račun…",
    scanningOne: "Skeniram račun…", scanningMany: "Skeniram {count} računa…",
    scanningSample: "Skeniram primjer računa…",
    blockedTitle: "Mjesečna kvota skeniranja je iskorištena",
    blockedBody: "Iskoristili ste {used} od {total} skeniranja u paketu {plan}. Odaberite veći paket da nastavite skenirati.",
    viewPlans: "Pogledaj pakete",
    remaining: "Preostalo {count} skeniranja u ovom mjesecu",
    overage: "Prekoračenje se naplaćuje {price} po skeniranju",
    couldNotRead: "Nije moguće pročitati {name}", tryBetterPhoto: "Pokušajte s oštrijom, bolje osvijetljenom fotografijom.",
    needsReviewToast: "{vendor} treba provjeru",
  },
  duplicates: {
    title: "Provjera duplikata",
    sub: "Mogući dvostruko poslani ili sumnjivi računi — odlučite što ostaje u obračunu",
    emptyTitle: "Nema duplikata za provjeru",
    emptyBody: "Kad sustav prepozna istu sliku ili isti račun (isti izdavatelj, datum i iznos), pojavit će se ovdje.",
    reasonImage: "Ista fotografija je već poslana",
    reasonSame: "Isti izdavatelj, datum i iznos kao postojeći račun",
    newReceipt: "Novi račun", originalReceipt: "Postojeći račun",
    keepBoth: "Nije duplikat — zadrži", confirmDup: "Potvrdi duplikat (odbij)",
    deleteScan: "Izbriši skeniranje",
    keptToast: "Račun zadržan u obračunu", confirmedToast: "Duplikat odbijen — ne ulazi u obračun",
    deletedToast: "Skeniranje izbrisano",
    uploadedBy: "Poslao/la", pending: "{count} za provjeru",
  },
  reports: {
    title: "Izvještaji", sub: "Obračuni troškova i PDV-a spremni za knjigovodstvo",
    employee: "Partner / Vozač", include: "Uključi", includeAll: "Svi računi u obračunu",
    includeApproved: "Samo odobreni", resetFilters: "Poništi",
    receiptsCount: "Računa", netTotal: "Osnovica", vatTotal: "PDV ukupno",
    grossTotal: "Ukupno s PDV-om", refunds: "Naknade",
    vatRecap: "Rekapitulacija PDV-a po stopama", refundsPerEmployee: "Naknade po zaposleniku",
    receiptDetail: "Detalji računa", nothingTitle: "Još nema što izvijestiti",
    nothingBody: "Skenirajte račune ili proširite razdoblje da izgradite obračun.",
    periodInfo: "{count} računa · razdoblje {period}",
    emailReport: "Pošalji knjigovođi",
    emailTitle: "Pošalji obračun e-poštom",
    emailSub: "Obračun se šalje kao PDF i/ili CSV prilog za odabrano razdoblje.",
    addRecipient: "Dodaj primatelja (e-pošta)", attachments: "Prilozi",
    sentToast: "Obračun poslan na {count} adresa",
    monthlyTitle: "Automatski mjesečni obračun",
    monthlySub: "Prvog dana mjeseca sustav šalje obračun za prethodni mjesec.",
    sendNow: "Pošalji prošli mjesec", history: "Povijest slanja",
    downloadedCsv: "CSV izvještaj preuzet", downloadedPdf: "PDF izvještaj preuzet",
    vatRate: "Stopa PDV-a",
    noVatData: "Nema podataka o PDV-u za odabrane filtere.",
    presetUniversal: "Univerzalni CSV",
    presetSynesis: "Synesis (eURA.txt)",
    presetMinimax: "Minimax (Minimax_URA.csv)",
    presetHint: "Univerzalni CSV (;) sadrži link na račun. Synesis izvozi eURA.txt razdvojen tabulatorom, a Minimax Minimax_URA.csv (;) — oba u strogom rasporedu s datumima DD.MM.GGGG.",
    emptyExport: "Nema računa za odabrano razdoblje — CSV sadrži samo zaglavlje.",
    accountingExports: "Knjigovodstvo",
    downloadPdf: "Preuzmi PDF",
    pdfStandard: "PDF",
    pdfWithAttachments: "PDF s prilozima",
    payoutTitle: "Za isplatu zaposlenicima",
    payoutSub: "Koliko treba prebaciti svakom zaposleniku za odabrano razdoblje (naknade koje još nisu isplaćene).",
    payoutEmail: "E-pošta",
    payoutOwed: "Za isplatu",
    payoutExport: "Izvezi listu isplata",
    payoutDownloaded: "Lista isplata preuzeta",
    payoutEmpty: "Nema naknada za isplatu u odabranom razdoblju.",
    accountingPdf: "PDF s prilozima",
    accountingPdfHint: "Naslovnica sa sažetkom i PDV-om + po jedna stranica za svaki račun (slika + podaci).",
    exportQueued: "Izvoz se priprema u pozadini — poslat ćemo link na {email}.",
    exportReady: "Izvoz je pripremljen",
    exportFailed: "Priprema izvoza nije uspjela",
    docsTitle: "Izdani dokumenti",
    docsSub: "Svaki izvoz i poslani izvještaj dobiva svoj broj dokumenta (npr. IZV-2026-0001).",
    docNumber: "Dokument br.",
    docKind: "Vrsta",
    docPeriod: "Razdoblje",
    docBy: "Izdao",
    docsEmpty: "Još nema izdanih dokumenata — izvezite ili pošaljite izvještaj i broj se dodjeljuje automatski.",
    docKinds: {
      export_csv: "CSV izvoz",
      export_pdf: "PDF izvoz",
      report: "Izvještaj e-poštom",
      monthly_report: "Mjesečni izvještaj",
    },
  },
  team: {
    title: "Tim", sub: "Pozovite vozače, servisere, partnere i knjigovođu",
    invitePerson: "Pozovi osobu", inviteTitle: "Pozovite u svoje društvo",
    inviteSub: "Primatelj dobiva poruku s linkom za postavljanje lozinke. Zaposlenici mogu samo slati račune i vidjeti svoju povijest.",
    inviteEmail: "E-pošta", inviteName: "Ime (neobavezno)", inviteRole: "Rola",
    createInvite: "Kreiraj poziv", inviteCreated: "Poziv kreiran",
    inviteCopied: "Link poziva kopiran u međuspremnik.",
    inviteEmailed: "Poziv poslan e-poštom na {email}",
    seatsInUse: "Zauzeta mjesta", pendingInvites: "{count} poziva na čekanju",
    seatFree: "Knjigovođe ne zauzimaju mjesto",
    rolePermissions: "Ovlasti po roli",
    adminPerm: "Administrator društva",
    adminPermBody: "Cijela nadzorna ploča, svi računi, odobravanja, PDV i naknade, izvještaji i pretplata.",
    employeePerm: "Partner / Vozač",
    employeePermBody: "Samo mobilno slanje: fotografira račune, prati status i vidi svoje naknade.",
    accountantPerm: "Knjigovođa (samo pregled)",
    accountantPermBody: "Vidi sve račune i izvještaje, izvozi PDF/CSV — ne može mijenjati, odobravati ni podešavati.",
    pendingTitle: "Pozivi na čekanju", copyLink: "Kopiraj link",
    membersTitle: "Članovi", colExpenses: "Troškovi", colAccess: "Pristup",
    colOverride: "Pravilo naknade", colRemove: "Ukloni",
    overrideSet: "Vlastito pravilo", overrideNone: "Pravilo društva",
    overrideButton: "Uredi pravilo",
    roleChanged: "{name} je sada {role}",
    accessDisabled: "Pristup onemogućen", accessRestored: "Pristup vraćen",
    removed: "{name} uklonjen/a",
  },
  override: {
    title: "Naknada za {name}",
    sub: "Vlastito pravilo ima prednost pred pravilom društva i pravilima po kategoriji.",
    enable: "Koristi vlastito pravilo za ovu osobu",
    basis: "Osnova naknade", vatPct: "% PDV-a", grossPct: "% ukupnog iznosa",
    cap: "Maksimalno po računu", note: "Napomena (neobavezno)",
    example: "Primjer — račun {gross} s {vat} PDV-a daje naknadu",
    saved: "Pravilo naknade spremljeno ({count} računa preizračunato)",
    removed: "Vlastito pravilo uklonjeno",
    remove: "Ukloni vlastito pravilo",
  },
  settings: {
    title: "Postavke", sub: "PDV stope, pravila naknada, kategorije, obavijesti i podaci društva",
    tabRefunds: "Naknade", tabVat: "PDV stope", tabCategories: "Kategorije",
    orgTypeSub: "Određuje koje funkcije prikazujemo. Knjigovodstveni servis ne vidi interne naknade vozačima ni „pošalji knjigovođi“.",
    orgTypeSaved: "Vrsta organizacije ažurirana",
    tabNotifications: "Obavijesti", tabCompany: "Društvo",
    companyDefault: "Zadano pravilo društva",
    companyDefaultSub: "Koliki dio svakog računa vraćate zaposleniku ili partneru koji je platio.",
    refundBasis: "Osnova naknade", modeVat: "Postotak PDV-a", modeGross: "Postotak ukupnog iznosa",
    modeBoth: "Oboje (% PDV-a + % ukupnog)",
    ofVatPct: "% PDV-a", ofTotalPct: "% ukupnog", capPerReceipt: "Maksimalno po računu",
    noCap: "bez ograničenja",
    example: "Primjer — račun od {gross} s {vat} PDV-a daje naknadu",
    saveRecalculate: "Spremi i preizračunaj",
    perCategory: "Pravila po kategoriji",
    perCategorySub: "Nadjavajte zadano pravilo za pojedine vrste troška (npr. 100 % PDV-a za gorivo, ništa za reprezentaciju).",
    addCategoryRule: "Dodaj pravilo kategorije…",
    noOverrides: "Nema iznimki — sve kategorije koriste zadano pravilo društva.",
    colBasis: "Osnova", colExample: "Primjer",
    vatRatesTitle: "Stope PDV-a",
    vatRatesSub: "Stope koje se mogu pojaviti na vašim računima. Zadano prati hrvatske stope.",
    addRate: "Dodaj stopu", colPercent: "Postotak", colActive: "Aktivno",
    saveVat: "Spremi stope PDV-a",
    categoriesTitle: "Kategorije troškova", addCategory: "Dodaj kategoriju",
    colLabel: "Naziv", colKey: "Ključ", colColour: "Boja", saveCategories: "Spremi kategorije",
    companyProfile: "Podaci društva", addressField: "Adresa",
    autoApprove: "Automatski odobri čiste račune",
    autoApproveSub: "Računi kod kojih se PDV poklapa i pouzdanost je visoka preskoče ručnu provjeru.",
    allowOverage: "Dozvoli naplaćeno prekoračenje kvote",
    allowOverageSub: "Kad je uključeno, skeniranje se nastavlja i nakon uključenog broja te se dodatna skeniranja naplaćuju. Kad je iskljlučeno, skeniranje se blokira na kvoti.",
    saveProfile: "Spremi podatke",
    notifTitle: "Obavijesti e-poštom",
    notifSub: "Automatske poruke administratorima, zaposlenicima i knjigovođi.",
    emailOn: "E-pošta je podešena — poruke se dostavljaju preko SendGrida ({sender}).",
    emailOff: "E-pošta nije podešena — poruke se bilježe, ali se ne dostavljaju. Dodajte SENDGRID_API_KEY u backend/.env.",
    notifInvites: "Pozivi u tim", notifInvitesSub: "Pošalji link za postavljanje lozinke pozvanoj osobi.",
    notifReview: "Računi za provjeru", notifReviewSub: "Obavijesti administratore kad račun zahtijeva provjeru.",
    notifQuota: "Upozorenja o kvoti", notifQuotaSub: "Obavijesti na 80 % i 100 % mjesečne kvote skeniranja.",
    monthlyReport: "Mjesečni obračun knjigovođi",
    monthlyReportSub: "Automatski pošalji obračun prošlog mjeseca odabranim primateljima.",
    monthlyDay: "Dan u mjesecu", monthlyRecipients: "Primatelji (odvojeni zarezom)",
    monthlyFormats: "Formati priloga",
    sendTest: "Pošalji testnu poruku", testSent: "Testna poruka poslana",
    emailLog: "Dnevnik poslanih poruka", logTo: "Primatelj", logSubject: "Predmet",
    logKind: "Vrsta", logStatus: "Status", noEmails: "Još nema poslanih poruka.",
    logDelivery: "Dostava",
    webhookOn: "SendGrid webhook je povezan — statusi dostave, otvaranja i odbijanja ažuriraju se automatski.",
    webhookOff: "Dodajte SENDGRID_WEBHOOK_PUBLIC_KEY u backend/.env i webhook u SendGridu da vidite dostavu, otvaranja i odbijanja.",
    webhookBadgeOn: "Praćenje dostave aktivno",
    webhookBadgeOff: "Praćenje dostave nije podešeno",
    opensShort: "{n}× otvoreno",
    clicksShort: "{n}× klik",
    delivery: {
      processed: "U obradi", deferred: "Odgođeno", delivered: "Dostavljeno",
      open: "Otvoreno", click: "Kliknuto", bounce: "Odbijeno", blocked: "Blokirano",
      dropped: "Odbačeno", spamreport: "Prijava spama", unsubscribe: "Odjava",
      group_unsubscribe: "Odjava iz grupe", group_resubscribe: "Ponovna prijava",
    },
    saveNotifications: "Spremi obavijesti",
    savedCompany: "Podaci društva spremljeni", savedVat: "Stope PDV-a spremljene",
    savedCategories: "Kategorije spremljene",
    savedRules: "Pravila naknada spremljena", recomputed: "{count} računa preizračunato",
    savedNotifications: "Postavke obavijesti spremljene",
  },
  billing: {
    seatsHint: "Mjesta se automatski obračunavaju prema broju aktivnih korisnika.",
    statuses: { trialing: "Probni period", active: "Aktivna", past_due: "Neplaćeno", canceled: "Otkazana", incomplete: "Nedovršena", unpaid: "Neplaćena" },
    title: "Pretplata i naplaćivanje",
    sub: "Cijena po korisniku s uključenim brojem skeniranja i transparentnim prekoračenjem",
    modeUnconfiguredTitle: "Naplaćivanje nije podešeno",
    modeUnconfiguredBody: "Dodajte svoj Stripe tajni ključ kao STRIPE_API_KEY na serveru da omogućite pretplate. Ostatak aplikacije radi normalno.",
    modeTestTitle: "Stripe testni način",
    modeTestBody: "Naplata radi preko platformskog testnog ključa pa su pretplate simulirane od početka do kraja. Dodajte vlastiti Stripe ključ za rad uživo te korisnički portal i sinkronizaciju mjesta.",
    modeByokTitle: "Povezano s vašim Stripe računom",
    modeByokBody: "Pretplate, korisnički portal i automatska sinkronizacija mjesta rade na vašim ključevima.",
    currentPlan: "Trenutni paket", statusLabel: "Status", trialEnds: "Probni period do",
    scansThisMonth: "Skeniranja ovaj mjesec", billingPeriod: "Obračunsko razdoblje",
    activeSeats: "Aktivna mjesta", syncSeats: "Sinkroniziraj mjesta",
    thisMonthUsage: "Ovaj mjesec pri trenutnoj potrošnji",
    platformFee: "Osnovna naknada", seatsWord: "mjesta", extraScans: "dodatnih skeniranja",
    noOverage: "bez prekoračenja",
    choosePlan: "Odaberite paket",
    choosePlanSub: "Mjesta se naplaćuju mjesečno; skeniranja iznad uključenog broja naplaćuju se po skeniranju.",
    seatsToBuy: "Broj mjesta", popular: "Najpopularnije", current: "Trenutno",
    subscribeTo: "Pretplati se na {plan}", updateSubscription: "Ažuriraj pretplatu",
    includedOnSignup: "Uključeno pri otvaranju", perExtraScan: "{price} po dodatnom skeniranju",
    checkoutHistory: "Povijest naplate", colStarted: "Započeto", colSeats: "Mjesta",
    colAmount: "Iznos", colPayment: "Plaćanje", portal: "Korisnički portal",
    redirecting: "Preusmjeravam na sigurnu Stripe naplatu…",
    seatsSynced: "Broj mjesta postavljen na {count}",
    overageOn: "Prekoračenje dozvoljeno", overageOff: "Prekoračenje blokirano",
  },
  employee: {
    greeting: "Zdravo {name}", sub: "Fotografirajte račun i odmah je evidentiran u uredu",
    myExpenses: "Moji troškovi", myRefund: "Moja naknada", approvedWord: "odobreno",
    lastReceipts: "Moji zadnji računi", seeAll: "Prikaži sve",
    nothingYet: "Još ništa — fotografirajte svoj prvi račun iznad.",
    refundPolicy: "Vaše pravilo naknade",
    policyVat: "Dobivate {pct} % PDV-a sa svakog računa.",
    policyGross: "Dobivate {pct} % ukupnog iznosa svakog računa.",
    policyBoth: "Dobivate {vat} % PDV-a i {gross} % ukupnog iznosa.",
    categoryNote: " Neke kategorije imaju vlastitu stopu.",
    myReceiptsTitle: "Moji računi", myReceiptsSub: "Sve što ste poslali",
    filterAll: "Sve", filterScanning: "Skeniranje", filterReview: "Za provjeru",
    filterApproved: "Odobreno",
    emptyTitle: "Ovdje još nema računa",
    emptyBody: "Računi koje fotografirate pojavljuju se ovdje sa statusom i zarađenom naknadom.",
    refundsTitle: "Moje naknade", refundsSub: "Koliko vam društvo vraća",
    totalEarned: "Ukupno zarađeno", waiting: "Na čekanju", byMonth: "Naknade po mjesecima",
    monthlyDetail: "Detalji po mjesecu", spent: "Potrošeno", noRefunds: "Još nema naknada",
    startScanning: "Skenirajte račune da počnete zarađivati naknade.",
    datePending: "datum u obradi",
    myRuleTitle: "Moje pravilo naknade",
    myRuleSub: "Ovako se izračunava vaša naknada",
    myRuleCustom: "Osobno pravilo",
    myRuleCompany: "Pravilo društva",
    myRuleCustomNote: "Administrator vam je postavio osobnu stopu — različitu od standardne.",
    myRuleCompanyNote: "Na vas se primjenjuje standardno pravilo društva.",
    ruleBase: "Osnovna stopa",
    ruleCap: "Najviše {amount} po računu",
    ruleNoCap: "Bez gornje granice po računu",
    ruleApproval: "Naknada se isplaćuje nakon odobrenja administratora.",
    ruleNoApproval: "Naknada se priznaje automatski, bez odobrenja.",
    ruleByCategory: "Stope po kategorijama",
    ruleSpecialHint: "Ove kategorije imaju drukčiju stopu od vaše osnovne.",
    ruleShowAll: "Prikaži sve kategorije",
    ruleHideAll: "Sakrij kategorije",
    ruleAdminNote: "Napomena administratora",
    ruleVatShort: "{pct} % PDV-a",
    ruleGrossShort: "{pct} % ukupnog iznosa",
    ruleBothShort: "{vat} % PDV-a + {gross} % ukupnog iznosa",
    ruleExample: "Primjer: na računu od {gross} s {vat} PDV-a dobivate {refund}.",
  },
  alerts: {
    title: "Obavijesti",
    bell: "Otvori obavijesti",
    unread: "{n} nepročitano",
    markAll: "Označi sve kao pročitano",
    emptyTitle: "Nema obavijesti",
    emptyBody: "Ovdje se pojavljuju računi za provjeru, odobrenja, kvote i izvještaji.",
    onlyUnread: "Samo nepročitane",
    justNow: "upravo sada",
    kinds: {
      refund_paid: "Naknada isplaćena",
      refund_paid_batch: "Naknade isplaćene",
      trial_ending: "Probni period završava",
      payment_failed: "Plaćanje nije uspjelo",
      receipt_needs_review: "Račun treba provjeru",
      receipt_duplicate: "Moguć duplikat računa",
      receipt_failed: "Skeniranje nije uspjelo",
      receipt_approved: "Račun odobren",
      receipt_rejected: "Račun odbijen",
      member_joined: "Novi član tima",
      quota_warning: "Kvota skeniranja",
      quota_blocked: "Kvota iskorištena",
      report_sent: "Izvještaj poslan",
      refund_rule_changed: "Promjena pravila naknade",
    },
    bodies: {
      refund_paid: "{vendor} · naknada {refund} je isplaćena.",
      refund_paid_batch: "Isplaćeno vam je {refund} naknade.",
      trial_ending: "Probni period pretplate uskoro istječe.",
      payment_failed: "Zadnje plaćanje pretplate nije uspjelo ({amount} {currency}).",
      receipt_needs_review: "{vendor} · {amount} — poslao/la {employee}",
      receipt_duplicate: "{vendor} · {amount} izgleda kao već evidentiran račun",
      receipt_failed: "Račun „{filename}\" nije uspješno pročitan. Pokušajte ponovno fotografirati.",
      receipt_approved: "{vendor} · {amount} — naknada {refund}",
      receipt_rejected: "{vendor} · {amount} — razlog: {reason}",
      member_joined: "{name} se pridružio/la timu ({email})",
      quota_warning: "Iskorišteno {used} od {included} skeniranja ({pct} %) na paketu {plan}.",
      quota_blocked: "Iskorišteno {used} od {included} skeniranja — daljnja skeniranja su zaustavljena.",
      report_sent: "Izvještaj za {period} poslan na {count} adresa ({recipients}).",
      refund_rule_changed: "Administrator je ažurirao vaše osobno pravilo naknade.",
    },
  },
  plans: {
    trial: {
      name: "Besplatna proba",
      tagline: "14 dana, bez kartice",
      features: ["50 skeniranja računa", "Do 5 korisnika", "Razrada PDV-a i naknade",
                 "CSV izvoz"],
    },
    starter: {
      name: "Početni",
      tagline: "Manji timovi i obrtnici",
      features: ["150 skeniranja mjesečno", "Do 10 korisnika",
                 "PDF i CSV izvoz za knjigovodstvo", "Pravila naknade po kategoriji",
                 "Podrška e-poštom"],
    },
    growth: {
      name: "Rast",
      tagline: "Transportne flote i izvođači",
      features: ["750 skeniranja mjesečno", "Do 50 korisnika",
                 "Računi u stvarnom vremenu i odobravanja", "Otkrivanje duplikata",
                 "Prioritetna podrška"],
    },
    scale: {
      name: "Poslovni",
      tagline: "Knjigovodstveni servisi i grupe društava",
      features: ["5 000 skeniranja mjesečno", "Neograničeno korisnika",
                 "Neograničeni izvoz izvještaja", "Zapisnik radnji",
                 "Vođeno uvođenje u rad"],
    },
    enterprise: {
      name: "Enterprise",
      tagline: "Za velike knjigovodstvene servise i partnerske mreže",
      features: ["15 000 skeniranja mjesečno", "Neograničeno korisnika",
                 "Pregled više društava", "Zapisnik radnji i izvoz podataka",
                 "Dodijeljeni voditelj računa"],
    },
  },
  clients: {
    switcher: "Klijenti",
    ownWorkspace: "Vaš servis",
    addClient: "Dodaj klijenta",
    clientName: "Naziv klijenta",
    clientTaxId: "OIB klijenta (nije obavezno)",
    addHint: "Otvara se zasebna radna površina za tog klijenta — računi, PDV i izvoz su odvojeni.",
    createCta: "Otvori radnu površinu",
    created: "Klijent {name} je otvoren",
    switched: "Radna površina promijenjena",
  },
  legal: {
    terms: "Uvjeti korištenja", privacy: "Politika privatnosti", refund: "Politika povrata",
    lastUpdated: "Zadnja izmjena", backHome: "Natrag na početnu", contact: "Kontakt",
    otherDocs: "Ostali dokumenti",
  },
};

export default hr;
